import { Phone, Mail, MapPin } from "lucide-react";

const SERVICES = [
  "Legal Basements",
  "Custom Homes",
  "Kitchen & Bath",
  "Painting",
  "Flooring",
  "Electric & Plumbing",
  "Emergency Services",
];

export default function Footer() {
  return (
    <footer className="bg-[#0B1B33] text-stone-300 relative overflow-hidden" data-testid="site-footer">
      <div className="absolute inset-0 grain pointer-events-none opacity-40" />
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#B08D5B]/60 to-transparent" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 relative">
        <div className="grid md:grid-cols-12 gap-12 lg:gap-16">
          <div className="md:col-span-5">
            <a href="#top" className="inline-flex items-center gap-3">
              <div className="w-12 h-12 border border-[#B08D5B] flex items-center justify-center">
                <span className="font-heading text-xl text-[#D4B888]">P</span>
              </div>
              <div className="leading-tight">
                <div className="font-heading text-2xl text-white font-medium">
                  Prime<span className="italic font-normal text-[#D4B888]">GTA</span>
                  <span className="font-light"> Remodeling</span>
                </div>
                <div className="text-[9px] uppercase tracking-[0.32em] text-stone-500 mt-1.5 font-body font-semibold">
                  Architecture · Design · Build
                </div>
              </div>
            </a>
            <p className="mt-7 font-body text-stone-400 leading-[1.85] text-[14px] max-w-md">
              Greater Toronto Area's trusted full-service remodeling studio. Legal basements,
              custom homes, kitchens, bathrooms, and 24/7 emergency response — built end to end
              by one accountable team.
            </p>
            <div className="mt-8 flex flex-col gap-3">
              <a
                href="tel:+14168264590"
                className="inline-flex items-center gap-3 text-stone-300 hover:text-[#D4B888] transition-colors text-[14px]"
                data-testid="footer-phone-1"
              >
                <Phone className="w-3.5 h-3.5 text-[#B08D5B]" /> +1 416 826 4590
              </a>
              <a
                href="tel:+16474466869"
                className="inline-flex items-center gap-3 text-stone-300 hover:text-[#D4B888] transition-colors text-[14px]"
                data-testid="footer-phone-2"
              >
                <Phone className="w-3.5 h-3.5 text-[#DC2626]" /> +1 647 446 6869
                <span className="label-overline text-[8px] text-[#fca5a5]">24/7</span>
              </a>
              <a
                href="mailto:primegtaremodeling@gmail.com"
                className="inline-flex items-center gap-3 text-stone-300 hover:text-[#D4B888] transition-colors break-all text-[14px]"
                data-testid="footer-email"
              >
                <Mail className="w-3.5 h-3.5 text-[#B08D5B] flex-shrink-0" />{" "}
                primegtaremodeling@gmail.com
              </a>
              <div className="inline-flex items-center gap-3 text-stone-400 text-[14px]">
                <MapPin className="w-3.5 h-3.5 text-[#B08D5B]" /> Greater Toronto Area, Canada
              </div>
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="label-overline text-[10px] text-[#D4B888] mb-6">Services</div>
            <ul className="space-y-3.5">
              {SERVICES.map((s) => (
                <li key={s}>
                  <a
                    href="#services"
                    className="font-body text-stone-300 hover:text-[#D4B888] transition-colors text-[14px]"
                  >
                    {s}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="label-overline text-[10px] text-[#D4B888] mb-6">Studio</div>
            <ul className="space-y-3.5 mb-10">
              {[
                { l: "About Us", h: "#why" },
                { l: "Gallery", h: "#gallery" },
                { l: "Reviews", h: "#reviews" },
                { l: "FAQ", h: "#faq" },
                { l: "Request a Quote", h: "#contact" },
              ].map((i) => (
                <li key={i.h}>
                  <a
                    href={i.h}
                    className="font-body text-stone-300 hover:text-[#D4B888] transition-colors text-[14px]"
                  >
                    {i.l}
                  </a>
                </li>
              ))}
            </ul>
            <div className="border border-[#DC2626]/30 p-6 relative">
              <div className="absolute top-0 left-0 w-8 h-px bg-[#DC2626]" />
              <div className="label-overline text-[9px] text-[#fca5a5] mb-2">
                Emergency Line · 24/7
              </div>
              <a
                href="tel:+16474466869"
                className="font-heading text-2xl text-white hover:text-[#D4B888] transition-colors font-medium"
                data-testid="footer-emergency-call"
              >
                +1 647 446 6869
              </a>
            </div>
          </div>
        </div>

        <div className="mt-20 pt-8 border-t border-stone-800 flex flex-col sm:flex-row gap-4 sm:items-center sm:justify-between">
          <p className="text-[11px] text-stone-500 font-body uppercase tracking-[0.18em]">
            © {new Date().getFullYear()} Primegtaremodeling. All rights reserved.
          </p>
          <p className="text-[11px] text-stone-500 font-body uppercase tracking-[0.18em]">
            Licensed & Insured · WSIB Covered
          </p>
        </div>
      </div>
    </footer>
  );
}
